interface Props {
  label: string;
  value: string;
  hint?: string;
}

export function KpiTile({ label, value, hint }: Props) {
  return (
    <div className="flex flex-col rounded-xl bg-[var(--color-secondary-bg)] px-3 py-3">
      <span className="text-xs uppercase tracking-wide text-[var(--color-muted)]">{label}</span>
      <span className="mt-1 text-2xl font-semibold text-[var(--color-fg)]">{value}</span>
      {hint ? <span className="mt-0.5 text-xs text-[var(--color-muted)]">{hint}</span> : null}
    </div>
  );
}
